<!-- 省市城市级联选择框 -->
<template>
  <article class="global-city">
    <Poptip v-model="visible" placement="bottom-start" transfer>
      <slot name="tip" />
      <template slot="title">
        <slot name="title" />
      </template>
      <ul class="global-city-list" slot="content">
        <li v-for="(item, index) in city" :key="item.cityId" @click.stop="handle(item, index)">
          {{ item.cityName || item.provinceName }}
        </li>
      </ul>
    </Poptip>
  </article>
</template>

<script>
import { Poptip } from 'iview';

export default {
  name: 'city-select',
  components: {
    Poptip,
  },
  props: {
    city: { // 城市列表
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    // 选择城市事件
    handle(item, index) {
      this.$emit('select', { item, index });
    },
    close() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>

</style>
